// src/pages/SessionExpired.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import illustration from 'assets/img/avatars/LogoAtlantis.png';

const SessionExpired = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      // Remove authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // If you have other token keys, remove them here
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      navigate('/login', { replace: true });
    }
  }, [seconds, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
      }}
    >
      <img
        src={illustration}
        alt="Atlantis"
        style={{
          width: '250px',
          height: 'auto',
        }}
      />

      <h1>Session Expired</h1>

      <p>
        Your session has expired. Please login again.
      </p>

      <p>
        Redirecting to login in{' '}
        <strong>{seconds}</strong> seconds...
      </p>
    </div>
  );
};

export default SessionExpired;